import type { FiatFlow, SubmitTransition } from '@funkit/connect-core'

import { logger } from '../logging/logger'
import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { formatFiat } from '../utils/formatAmount'
import { FiatStatusScreen } from './FiatStatusScreen'

export function FiatPendingOrderScreen({
  flow,
  onResumeAmount,
  onClose,
}: {
  flow: FiatFlow
  onResumeAmount: (amount: string) => void
  onClose: () => void
}) {
  const { t } = useFunkitTranslation()
  const state = flow.stepResponse?.state
  if (state?.kind !== 'PENDING_ORDER') {
    return null
  }
  const { order } = state
  const action = (id: string, label: string) => {
    const transition = flow.ctas.find((cta) => cta.id === id)
    if (transition === undefined) {
      return undefined
    }
    return { label, onPress: () => submit(transition) }
  }
  const submit = (transition: SubmitTransition) => {
    if (flow.isInFlight) {
      return
    }
    logger.info('connect-rn:fiat:pending_order_action', {
      action: transition.id,
      orderId: order.orderId,
      provider: flow.stepResponse?.provider,
    })
    // Resuming restores the original price beside its hosted payment button.
    if (transition.id === 'resume') {
      onResumeAmount(order.fiat.amount)
    }
    void flow.submit(transition)
  }

  return (
    <FiatStatusScreen
      tone="notice"
      title={t('fiat.pendingOrderTitle')}
      detail={t('fiat.pendingOrderDetail', {
        amount: formatFiat(Number(order.fiat.amount), order.fiat.currency),
      })}
      cta={action('resume', t('fiat.resumeDeposit'))}
      secondaryCta={action('cancel', t('fiat.cancelDeposit'))}
      isSubmitting={flow.isInFlight}
      onClose={onClose}
    />
  )
}
